<template>
    <div v-if="banners.length">
        <div v-for="banner of banners">
            <img v-if="!banner.link" :src="banner.image" />
            <a v-else-if="banner.link.toLowerCase().startsWith('http')" :href="banner.link" target="_blank"><img :src="banner.image" /></a>
            <router-link v-else-if="banner.link.startsWith('/')" :to="{ path: banner.link }"><img :src="banner.image" /></router-link>
            <router-link v-else :to="{ name: banner.link }"><img :src="banner.image" /></router-link>
        </div>
    </div>
</template>
<script>
    export default {
        name: "sport-column-banners",
        props: { banners: { required: true, type: Array } }
    };
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/sport-banners/sport-column-banners.vue